import {BaseApi} from "@/core/api/base.api";
import {roomLmsService} from "@/core/service/room.lms.service";
import {Room} from "@/core/api/room.api";

class RoomLmsApi extends BaseApi {
    constructor() {
        super();
        Room.Lms = this;
    }

    async getLmsUserList() {
        return await roomLmsService.getLmsUserList();
    }

    async sendSMSToLmsUser(params) {
        return await roomLmsService.sendSMSToLmsUser(params);
    }

    async sendSMSToAllLmsUser(params) {
        return await roomLmsService.sendSMSToAllLmsUser(params);
    }
}

export const RoomLms = new RoomLmsApi()